import { CustomerManagementUserContactEnum } from "_constants";

/**
 * Finds the primary and secondary phone number contacts from a contact list.
 *
 * @param {Array<Object>} contacts - Array of contact objects.
 * @returns {{ primaryPhoneNumberContact?: Object, secondaryPhoneNumberContact?: Object }}
 *
 **/

export const getPrimaryAndSecondaryPhoneNumber = (contacts) => {
  if (!Array.isArray(contacts))
    return {
      primaryPhoneNumberContact: undefined,
      secondaryPhoneNumberContact: undefined,
    };

  const [primaryPhoneNumberContact, secondaryPhoneNumberContact] =
    contacts.reduce(
      ([primary, secondary], contact) => {
        if (contact?.type === CustomerManagementUserContactEnum.PHONE) {
          if (contact.isPrimary) {
            primary = contact;
          } else {
            secondary = contact;
          }
        }
        return [primary, secondary];
      },
      [undefined, undefined]
    );

  return { primaryPhoneNumberContact, secondaryPhoneNumberContact };
};
